module.exports = __webpack_public_path__ + "static/media/csulb_logo.07e439f2.png";